import https from "@/utils/https";
import {Root} from "@/models/root";
import {Method} from "axios-mapper";
import {CourseVO} from "@/apis/course";

export interface LoginInfo {
  userId: number;
  realName: string;
  nickname: string;
  avatar: string;
  role: string;
  appName: string;
  accessToken: string;
  refreshToken: string;
  secret: string;
  openId: string;
  unionId: string;
  zhihuUid: string;
  appleId: string;
  needSetPhone: boolean;
  needBindWeChat: boolean;
}

export type LoginType = 'EMAIL' | 'PHONE'

export interface PasswordLoginParam {
  phone?: string;
  email?: string;
  username?: string;
  password: string;
  loginType: LoginType;
  appName: string;
  version: string;
}

/**
 * 密码登录
 * @param data
 */
export const loginByPassword = (data: PasswordLoginParam): Promise<Root<CourseVO> | null> => {
  return https(false).request<Root<CourseVO>>(`/auth/login/pwd`, Method.POST, data)
}
